<template>
<div class="mExcitation">
    <Header></Header>
    <div class="content_warp">
        <div class="top_box">
            <p class="p_title">股权激励方案定制助手</p>
            <p class="p_desc">一键生成专业实操方案，内容全面细致，让企业轻松搞定股权激励</p>
            <button @click="FreeGetBtn" class="btn">免费获取</button>
        </div>
        <div class="warp1">
            <img class="inset_img" :src="require('@/common/images/gujing/excitation/jl-icon_1.png')" alt="">
            <div class="explain_box">
                <p class="title_text">全面考虑方案设计核心要素</p>
                <p class="desc_text">方案囊括股权激励全部核心要素，内容涵盖股份来源、持股方式、激励对象范围、激励股份总量与个量分配、授予价格、分红规定、退出机制等，确保方案完整、内容全面。</p>
            </div>
        </div>
        <div class="warp2">
            <img class="inset_img" :src="require('@/common/images/gujing/excitation/jl-icon_2.png')" alt="企业估值">
            <div class="explain_box">
                <p class="title_text">专业智能化的估值技术</p>
                <p class="desc_text">符合企业实际情况和激励需求<br/>拒绝套路性模板<br/>方案可直接落地实施</p>
            </div>
        </div>
        <div class="warp1">
            <img class="inset_img2" :src="require('@/common/images/gujing/excitation/jl-icon_3.png')" alt="">
            <div class="explain_box">
                <p class="title_text">合法合规 规避风险</p>
                <p class="desc_text">规避雷区、排除隐患<br/>确保方案在法律框架下有效运行</p>
            </div>
        </div>
        <div class="warp3">
            <p class="title_text">专项服务</p>
            <div class="EPO_warp">
                <div class="EPO_item" v-for="(item, index) in EPOData" :key="index">
                    <img :src="item.imgUrl" alt="">
                    <p class="p_title">{{item.nameText}}</p>
                    <p class="p_desc" v-html="item.descText"></p>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
    <transition name="slide-fade">
        <img class="gotop_img" @click="goTop" v-show="show" :src="require('@/common/images/gujingimgs/go_top.png')" alt="">
    </transition>
</div>
</template>

<script>
import Header from 'views/gjMobile/components/Header'
import Footer from 'views/gjMobile/components/Footer'
import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
export default {
    name: 'MExcitation',
    data() {
        return {
            show: false,
            EPOData: [
                {
                    nameText: '股权架构设计',
                    imgUrl: require('@/common/images/gujing/excitation/jl-servce-icon_1.png'),
                    descText: '充分保障创始人控制权<br/>合理规划未来股权布局<br/>有效设计公司治理结构'
                },
                {
                    nameText: '股权激励落地实施',
                    imgUrl: require('@/common/images/gujing/excitation/jl-servce-icon_2.png'),
                    descText: '配套文件撰写<br/>方案落地宣讲<br/>知识培训与答疑<br/>授予仪式协助'
                },
                {
                    nameText: '财税筹划',
                    imgUrl: require('@/common/images/gujing/excitation/jl-servce-icon_3.png'),
                    descText: '税收优惠政策指导<br/>股权重组财税筹划<br/>税收风险防范<br/>股份支付财税测算'
                },
                {
                    nameText: '持股平台搭建',
                    imgUrl: require('@/common/images/gujing/excitation/jl-servce-icon_4.png'),
                    descText: '持股平台架构设计<br/>预留股份设计<br/>定制化合伙协议设计<br/>税收洼地持股平台便捷注册'
                },
            ]
        }
    },
    created() {
        // 判断是移动端还是PC端 并跳转到相应页面
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'Excitation'
            })
        }
    },
    activated() {
        $('html,body').animate({scrollTop:'0px'},0)
    },
    mounted() {
        $('html,body').animate({scrollTop:'0px'},0)
        let _this = this
        $(window).scroll(function () {
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            let clientHeight = document.body.clientHeight / 2
            if(scrollTop >= clientHeight){
                _this.show = true
            }
            else{
                _this.show = false
            }
        })
    },
    methods: {
        // 免费估值按钮
        FreeGetBtn() {
            if (this.user.isLogin) {
                // 跳转到估值页面
                this.$router.push({name: 'MStimulateStep'})
            } else {
                // 登录页面
                this.$router.push({name: 'MLogin'})
            }
        },
        // 回到顶部
        goTop() {
            $('html,body').animate({scrollTop:'0px'},300)
            // document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user',
            'domainInfo'
        ])
    },
    components: {Header,Footer}
}
</script>

<style lang="scss" type="text/scss">
@import "~common/scss/index";
.mExcitation {
    position: relative;
    background-color: #F5F7FA;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family:PingFangSC-Medium,PingFang SC;
    .content_warp {
        flex: 1;
        // padding-bottom: 0.2rem;
        .top_box {
            height: 5.6rem;
            background: url('../../../common/images/gujingimgs/intro-bg.png') no-repeat center;
            background-size: 100% 100%;
            color: #FFF;
            padding: 0 0.32rem;
            padding-top: 1.6rem;
            box-sizing: border-box;
            .p_title {
                font-size: 0.48rem;
                line-height: 0.68rem;
                font-weight: bold;
            }
            .p_desc {
                margin: 0.4rem 0;
                font-size: 0.3rem;
                line-height: 0.46rem;
            }
            .btn {
                width: 2.2rem;
                height: 0.6rem;
                font-size: 0.28rem;
                background:linear-gradient(90deg,rgba(46,234,227,1) 0%,rgba(41,135,255,1) 100%);
                border: none;
                border-radius: 0.3rem;
            }
        }
        .warp1, .warp2 {
            background-color: #fff;
            padding-top: 0.5rem;
            padding-bottom: 0.48rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            .inset_img {
                width: 4.4rem;
                height: 3.04rem;
                margin-bottom: 0.9rem;
            }
            .inset_img2 {
                width: 4.6rem;
                height: 3.14rem;
                margin-bottom: 0.9rem;
            }
            .explain_box {
                width: 100%;
                box-sizing: border-box;
                padding: 0 0.32rem;
                .title_text {
                    font-size: 0.36rem;
                    line-height: 0.5rem;
                    font-weight: bold;
                    position: relative;
                    margin-bottom: 0.12rem;
                    &::before {
                        content: '';
                        position: absolute;
                        bottom: -0.12rem;
                        width:0.36rem;
                        height:0.04rem;
                        background: #409EFF;
                    }
                }
                .desc_text {
                    font-size: 0.28rem;
                    color: #666;
                    line-height: 0.52rem;
                    padding: 0.48rem 0;
                }
            }
        }
        .warp2 {
            padding-top: 0.34rem;
            background-color: #F5F7FA;
            .inset_img {
                width: 4.6rem;
                height: 3.14rem;
                margin-bottom: 0.66rem;
            }
        }
        .warp3 {
            background-color: #F5F7FA;
            padding: 0 0.32rem;
            padding-top: 0.48rem;
            .title_text {
                position: relative;
                text-align: center;
                font-size: 0.36rem;
                line-height: 0.5rem;
                margin-bottom: 0.6rem;
                color: #333;
                font-weight: bold;
                &::before {
                    content: '';
                    position: absolute;
                    margin: auto;
                    bottom: -0.12rem;
                    left: 0;
                    right: 0;
                    width:0.36rem;
                    height:0.04rem;
                    background: #409EFF;
                }
            }
            .EPO_warp {
                display: flex;
                flex-wrap: wrap;
                .EPO_item {
                    width: 3.25rem;
                    height: 3.64rem;
                    background-color: #fff;
                    margin-bottom: 0.48rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    box-shadow:0 0.01rem 0.08rem 0 rgba(0,0,0,0.15);
                    border-radius:0.06rem;
                    &>img {
                        margin-top: 0.2rem;
                        width: 1rem;
                        height: 1rem;
                    }
                    .p_title {
                        margin: 0.2rem 0;
                        line-height: 0.4rem;
                        color: #333;
                        font-size: 0.28rem;
                    }
                    .p_desc {
                        text-align: center;
                        color: #666;
                        font-size: 0.2rem;
                        line-height: 0.36rem;
                    }
                }
                .EPO_item:nth-of-type(2n){
                    margin-left: 0.36rem;
                }
            }
        }
    }
    .gotop_img {
        width: 1.16rem;
        height: 1.16rem;
        position: fixed;
        right: 0.2rem;
        bottom: 1rem;
        opacity: 1;
    }
}
.slide-fade-enter-active, .slide-fade-leave-active {
    transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to{
    opacity: 0;
}
</style>